export const markWithRole = (selector: string, role: string) => {
  const target = document.querySelector(selector);
  if (target) {
    target.setAttribute('role', role);
    return true;
  }
  return false;
};
